import { SET_PAYOUTS } from 'constants/payouts';
import type { Payout } from 'models/payout';

type PayoutsAction = {
  type: typeof SET_PAYOUTS;
  payload: Payout[];
};

const payouts = (state: Payout[] = [], action: PayoutsAction) => {
  switch (action.type) {
    case SET_PAYOUTS:
      const { payload: payouts } = action;

      return payouts;
    default:
      return state;
  }
};

export { payouts };
